import BKW from 'elem/compPage/BKW';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/cost-saving';
import SEOlinksA from '@/components/SEOlinksA';

export default function BKWPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('bkw');
    const router = useRouter();
    const { locale = 'de' } = router;

    useEffect(() => {
        if (!['de'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <BKW />
        </PageLayout>
    );
}
